import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-layout-tree",
  "use": "app-icon-layout-tree-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"app-icon-layout-tree\"><g fill=\"none\" fill-rule=\"evenodd\"><rect stroke=\"#B8BECC\" fill=\"#FFF\" fill-rule=\"nonzero\" x=\".5\" y=\".5\" width=\"31\" height=\"31\" rx=\"1\" /><g stroke=\"#282B33\" stroke-width=\"1.5\"><path d=\"M13 7.5v3h-3v-3zM21.5 21v3h-3v-3zM21.5 13.5v3h-3v-3zM18.5 15h-7v7.619h7M11.5 15.5v-5\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol